import { FC, CSSProperties } from 'react'
/*
 * @dev: Common message for footer on QR claim system
 * */

type Props = {
  linkStyle?: CSSProperties
  expiryDate?: string
}

const ClaimFooterMessage: FC<Props> = ({ linkStyle, expiryDate }) => (
  <div className={'claim-footer'}>
    {expiryDate && <div className={'title'}>Celebrate! Mint your POAP before it expires on {expiryDate}</div>}
    <div className={'subtitle'}>
      <a style={linkStyle} href="https://help.poap.xyz/en/articles/5802657-how-do-i-set-up-a-poap-drop" target="_blank">
        Want to drop a POAP? Learn more!
      </a>{' '}
    </div>
  </div>
)

export default ClaimFooterMessage
